import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type BookLibraryCollectionService from 'teacher-ui-client/services/book-library/collection'
import type ReadingScalesService from 'teacher-ui-client/services/reading-scales'

interface Params extends Record<string, unknown> {
  collection_id: string
}

export default class BookLibraryCollectionShowRoute extends Route {
  @service('book-library/collection')
  collectionService!: BookLibraryCollectionService

  @service
  readingScales!: ReadingScalesService

  queryParams = {
    sort: {
      replace: true,
    },
    selected: {
      replace: true,
    },
    primaryFilterKey: {
      replace: true,
    },
  }

  model(params: Params) {
    return {
      collectionId: params.collection_id,
      loadCollection: this.collectionService.findCollection.perform(params.collection_id),
      loadBookCollections: this.collectionService.loadAllMyCollections.perform(),
      loadPrimaryFilters: this.readingScales.allPrimaryFilters.perform(),
    }
  }
}
